/* global angular */

export default function EditVendorDialogController(
  $rootScope,
  $scope,
  $q,
  alerts,
  ssDialogService,
  loaderService,
  vmSharedModelService
) {
  const vm = this;

  vm.newVendor = { ...vm.vendor };
  vm.handleClose = _handleClose;
  vm.handleSave = _handleSave;

  vm.validateURL = _validateURL;

  _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleClose() {
    _closeDialog();
  }

  function _handleSave() {
    if ($scope.bcpEditVendorForm.$invalid) {
      return Promise.resolve();
    }
    const isNew = vm.newVendor.vendorId < 0;

    if (!isNew && angular.equals(vm.vendor, vm.newVendor)) {
      // No need to save
      return _closeDialog();
    }
    loaderService.showViewLoader = true;

    if (vm.vendor.canDeleteVendor === undefined) { vm.vendor.canDeleteVendor = true; }
    if (vm.vendor.canEditVendor === undefined) { vm.vendor.canEditVendor = true; }
    if (vm.vendor.canViewVendor === undefined) { vm.vendor.canViewVendor = true; }

    return vmSharedModelService.saveVendor(vm.newVendor)
      .then((savedVendor) => {
        savedVendor.canDeleteVendor = vm.vendor.canDeleteVendor;
        savedVendor.canEditVendor = vm.vendor.canEditVendor;
        savedVendor.canViewVendor = vm.vendor.canViewVendor;
        angular.extend(vm.newVendor, savedVendor);
        angular.extend(vm.vendor, vm.newVendor);
        if (isNew) {
          $rootScope.$broadcast('vendorAdded', vm.vendor);
        }
        return _closeDialog().then(() => {
          alerts.success('The Vendor has been saved successfully.');
        });
      })
      .catch(() => {
        alerts.error('An error occurred while saving the Vendor.');
      })
      .finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    const que = [vmSharedModelService.getUnusedMasterVendors(vm.newVendor.masterVendorId)];
    if (vm.newVendor.vendorId > -1) {
      que.push(vmSharedModelService.getVendor(vm.newVendor.vendorId));
    }
    loaderService.showViewLoader = true;
    $q.all(que).then((results) => {
      loaderService.showViewLoader = false;
      vm.unusedMasterVendors = results[0];
      if (vm.newVendor.vendorId > -1) {
        vm.newVendor = results[1];
      }
    });
  }

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.bcp.editVendorDialog);
  }

  function _validateURL() {
    // eslint-disable-next-line max-len
    if (vm.newVendor.website.startsWith('http://') || vm.newVendor.website.startsWith('https://')) {
      vm.scope.bcpEditVendorForm.website.$invalid = false;
      vm.scope.bcpEditVendorForm.website.$error = '';
      vm.isValid = true;
    } else {
      vm.scope.bcpEditVendorForm.website.$invalid = true;
      vm.scope.bcpEditVendorForm.website.$error = { pattern: true };
    }
  }
}

EditVendorDialogController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  'alerts',
  'ssDialogService',
  'loaderService',
  'vmSharedModelService'
];
